"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncDropdownSelect = void 0;
require("core-js/modules/es.function.name.js");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _async = _interopRequireDefault(require("react-select/async"));
var _shared = require("./shared");
var _useSelectStyles = require("./useSelectStyles");
var _excluded = ["errorMessage", "name", "flexDirection", "placeholder", "subtitle", "title", "allowOther", "assertNotNull", "hasError", "options", "onChange", "styles", "selectedValue", "paddingLevel", "customDropdownIndicator", "filterOption", "isRequired", "isDisabled", "helperText"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1rawmllrvl() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Select/AsyncDropdownSelect.tsx";
  var hash = "b02c6dd9f675505183651e5991004332a931664f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Select/AsyncDropdownSelect.tsx",
    statementMap: {
      "0": {
        start: {
          line: 50,
          column: 72
        },
        end: {
          line: 140,
          column: 1
        }
      },
      "1": {
        start: {
          line: 73,
          column: 26
        },
        end: {
          line: 73,
          column: 65
        }
      },
      "2": {
        start: {
          line: 74,
          column: 20
        },
        end: {
          line: 74,
          column: 47
        }
      },
      "3": {
        start: {
          line: 75,
          column: 26
        },
        end: {
          line: 81,
          column: 37
        }
      },
      "4": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "5": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 35
        }
      },
      "6": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 24
        }
      },
      "7": {
        start: {
          line: 82,
          column: 25
        },
        end: {
          line: 82,
          column: 80
        }
      },
      "8": {
        start: {
          line: 84,
          column: 26
        },
        end: {
          line: 84,
          column: 43
        }
      },
      "9": {
        start: {
          line: 90,
          column: 38
        },
        end: {
          line: 90,
          column: 59
        }
      },
      "10": {
        start: {
          line: 91,
          column: 25
        },
        end: {
          line: 91,
          column: 50
        }
      },
      "11": {
        start: {
          line: 91,
          column: 31
        },
        end: {
          line: 91,
          column: 50
        }
      },
      "12": {
        start: {
          line: 92,
          column: 26
        },
        end: {
          line: 92,
          column: 52
        }
      },
      "13": {
        start: {
          line: 92,
          column: 32
        },
        end: {
          line: 92,
          column: 52
        }
      },
      "14": {
        start: {
          line: 94,
          column: 68
        },
        end: {
          line: 98,
          column: 3
        }
      },
      "15": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "16": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 41
        }
      },
      "17": {
        start: {
          line: 96,
          column: 32
        },
        end: {
          line: 96,
          column: 39
        }
      },
      "18": {
        start: {
          line: 103,
          column: 21
        },
        end: {
          line: 105,
          column: 47
        }
      },
      "19": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 66
        }
      },
      "20": {
        start: {
          line: 107,
          column: 2
        },
        end: {
          line: 139,
          column: 4
        }
      },
      "21": {
        start: {
          line: 128,
          column: 26
        },
        end: {
          line: 128,
          column: 47
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 50,
            column: 72
          },
          end: {
            line: 50,
            column: 73
          }
        },
        loc: {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 140,
            column: 1
          }
        },
        line: 72
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 75,
            column: 38
          },
          end: {
            line: 75,
            column: 39
          }
        },
        loc: {
          start: {
            line: 75,
            column: 44
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 75
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 91,
            column: 25
          },
          end: {
            line: 91,
            column: 26
          }
        },
        loc: {
          start: {
            line: 91,
            column: 31
          },
          end: {
            line: 91,
            column: 50
          }
        },
        line: 91
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 92,
            column: 26
          },
          end: {
            line: 92,
            column: 27
          }
        },
        loc: {
          start: {
            line: 92,
            column: 32
          },
          end: {
            line: 92,
            column: 52
          }
        },
        line: 92
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 94,
            column: 68
          },
          end: {
            line: 94,
            column: 69
          }
        },
        loc: {
          start: {
            line: 94,
            column: 75
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 94
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 21
          }
        },
        loc: {
          start: {
            line: 96,
            column: 32
          },
          end: {
            line: 96,
            column: 39
          }
        },
        line: 96
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 103,
            column: 35
          },
          end: {
            line: 103,
            column: 36
          }
        },
        loc: {
          start: {
            line: 103,
            column: 41
          },
          end: {
            line: 105,
            column: 3
          }
        },
        line: 103
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 128,
            column: 15
          },
          end: {
            line: 128,
            column: 16
          }
        },
        loc: {
          start: {
            line: 128,
            column: 26
          },
          end: {
            line: 128,
            column: 47
          }
        },
        line: 128
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 51,
            column: 17
          },
          end: {
            line: 51,
            column: 42
          }
        }],
        line: 51
      },
      "1": {
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 53,
            column: 41
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 9
          },
          end: {
            line: 53,
            column: 41
          }
        }],
        line: 53
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 54,
            column: 18
          },
          end: {
            line: 54,
            column: 26
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 55,
            column: 16
          },
          end: {
            line: 55,
            column: 27
          }
        }],
        line: 55
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 56,
            column: 13
          },
          end: {
            line: 56,
            column: 15
          }
        }],
        line: 56
      },
      "5": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 12
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 12
          }
        }],
        line: 57
      },
      "6": {
        loc: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 14
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 61,
            column: 12
          },
          end: {
            line: 61,
            column: 14
          }
        }],
        line: 61
      },
      "7": {
        loc: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 65,
            column: 17
          },
          end: {
            line: 65,
            column: 27
          }
        }],
        line: 65
      },
      "8": {
        loc: {
          start: {
            line: 73,
            column: 26
          },
          end: {
            line: 73,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 26
          },
          end: {
            line: 73,
            column: 39
          }
        }, {
          start: {
            line: 73,
            column: 43
          },
          end: {
            line: 73,
            column: 65
          }
        }],
        line: 73
      },
      "9": {
        loc: {
          start: {
            line: 74,
            column: 20
          },
          end: {
            line: 74,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 20
          },
          end: {
            line: 74,
            column: 28
          }
        }, {
          start: {
            line: 74,
            column: 32
          },
          end: {
            line: 74,
            column: 47
          }
        }],
        line: 74
      },
      "10": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 76
      },
      "11": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 95
      },
      "12": {
        loc: {
          start: {
            line: 115,
            column: 16
          },
          end: {
            line: 115,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 28
          },
          end: {
            line: 115,
            column: 45
          }
        }, {
          start: {
            line: 115,
            column: 48
          },
          end: {
            line: 115,
            column: 52
          }
        }],
        line: 115
      },
      "13": {
        loc: {
          start: {
            line: 122,
            column: 22
          },
          end: {
            line: 122,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 22
          },
          end: {
            line: 122,
            column: 34
          }
        }, {
          start: {
            line: 122,
            column: 38
          },
          end: {
            line: 122,
            column: 56
          }
        }],
        line: 122
      },
      "14": {
        loc: {
          start: {
            line: 124,
            column: 17
          },
          end: {
            line: 124,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 124,
            column: 30
          },
          end: {
            line: 124,
            column: 42
          }
        }, {
          start: {
            line: 124,
            column: 45
          },
          end: {
            line: 124,
            column: 52
          }
        }],
        line: 124
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0],
      "6": [0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b02c6dd9f675505183651e5991004332a931664f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1rawmllrvl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1rawmllrvl();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Use the Async component to load options from a remote source as the user types.
 * See https://react-select.com/async for more details
 *
 *
 * @param aria-label - The aria-label to use for the select. This can be left blank if the title is used OR an aria-labelledby attribute is passed in for an external label
 * @param aria-labelledby - The aria-labelledby to use for the select for use
 * @param loadOptions - allows users to either resolve from a callback or resolve from a
 *        returned promise.
 * @param defaultOptions - determines "when" your remote request is initially fired
 * @param selectedValue - the value of the selected option
 * @param onChange - callback for when the selected option changes
 * @param placeholder - placeholder text
 * @param subtitle - subtitle text
 * @param title - title text
 * @param allowOther - whether or not to allow the user to select the "other" option
 * @param assertNotNull - whether or not to assert that the selected option is not null
 * @param isDisabled - whether or not to disable the select
 * @param hasError - whether or not to display an error prompt
 * @param errorMessage - the error message to display
 * @param flexDirection - the direction of the flex container
 * @param name - the name of the select
 * @param options - the options to display
 * @param isSearchable - whether or not to allow the user to search
 * @param filterOption - callback for filtering the options
 * @param styles - the styles to apply to the select
 * @param customDropdownIndicator - a custom dropdown indicator
 * @param paddingLevel - the padding level to apply to the select
 * @param isMulti - whether or not to allow multiple selections
 * @param isClearable - whether or not to allow the user to clear the selection
 * @param isDisabled - whether or not to disable the select
 * @param isLoading - whether or not to display a loading indicator
 * @param menuIsOpen - whether or not the menu is open
 */
cov_1rawmllrvl().s[0]++;
var AsyncDropdownSelect = exports.AsyncDropdownSelect = function AsyncDropdownSelect(_ref) {
  var _ref4;
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? (cov_1rawmllrvl().b[0][0]++, 'Please make a selection') : _ref$errorMessage,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? (cov_1rawmllrvl().b[1][0]++, 'od-async-dropdown-select-large') : _ref$name,
    _ref$flexDirection = _ref.flexDirection,
    flexDirection = _ref$flexDirection === void 0 ? (cov_1rawmllrvl().b[2][0]++, 'column') : _ref$flexDirection,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? (cov_1rawmllrvl().b[3][0]++, 'Select...') : _ref$placeholder,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? (cov_1rawmllrvl().b[4][0]++, '') : _ref$subtitle,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? (cov_1rawmllrvl().b[5][0]++, '') : _ref$title,
    allowOther = _ref.allowOther,
    assertNotNull = _ref.assertNotNull,
    hasError = _ref.hasError,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? (cov_1rawmllrvl().b[6][0]++, []) : _ref$options,
    onChange = _ref.onChange,
    styles = _ref.styles,
    selectedValue = _ref.selectedValue,
    _ref$paddingLevel = _ref.paddingLevel,
    paddingLevel = _ref$paddingLevel === void 0 ? (cov_1rawmllrvl().b[7][0]++, 'standard') : _ref$paddingLevel,
    customDropdownIndicator = _ref.customDropdownIndicator,
    filterOption = _ref.filterOption,
    isRequired = _ref.isRequired,
    isDisabled = _ref.isDisabled,
    helperText = _ref.helperText,
    rest = _objectWithoutProperties(_ref, _excluded);
  cov_1rawmllrvl().f[0]++;
  var hasNotNullError = (cov_1rawmllrvl().s[1]++, (cov_1rawmllrvl().b[8][0]++, assertNotNull) && (cov_1rawmllrvl().b[8][1]++, (0, _isEmpty2["default"])(selectedValue)));
  var isInvalid = (cov_1rawmllrvl().s[2]++, (cov_1rawmllrvl().b[9][0]++, hasError) || (cov_1rawmllrvl().b[9][1]++, hasNotNullError));
  var getErrorMessage = (cov_1rawmllrvl().s[3]++, (0, _react.useCallback)(function () {
    cov_1rawmllrvl().f[1]++;
    cov_1rawmllrvl().s[4]++;
    if (hasNotNullError) {
      cov_1rawmllrvl().b[10][0]++;
      cov_1rawmllrvl().s[5]++;
      return _shared.ASSERT_NOT_NULL_ERROR;
    } else {
      cov_1rawmllrvl().b[10][1]++;
    }
    cov_1rawmllrvl().s[6]++;
    return errorMessage;
  }, [errorMessage, hasNotNullError]));
  var ariaLabelledby = (cov_1rawmllrvl().s[7]++, (0, _shared.getAriaLabelledby)(rest['aria-labelledby'], title, name));
  var getSelectStyles = (cov_1rawmllrvl().s[8]++, (0, _useSelectStyles.useSelectStyles)());

  /**
   * There seems to be an a11y bug where the Enter key doesn't open/close the control. The workaround is to
   * manage the `menuIsOpen` state ourselves and add a keydown handler that toggles the state when Enter is pressed.
   */
  var _ref2 = (cov_1rawmllrvl().s[9]++, _react["default"].useState(false)),
    _ref3 = _slicedToArray(_ref2, 2),
    menuIsOpen = _ref3[0],
    setMenuIsOpen = _ref3[1];
  cov_1rawmllrvl().s[10]++;
  var handleMenuOpen = function handleMenuOpen() {
    cov_1rawmllrvl().f[2]++;
    cov_1rawmllrvl().s[11]++;
    return setMenuIsOpen(true);
  };
  cov_1rawmllrvl().s[12]++;
  var handleMenuClose = function handleMenuClose() {
    cov_1rawmllrvl().f[3]++;
    cov_1rawmllrvl().s[13]++;
    return setMenuIsOpen(false);
  };
  cov_1rawmllrvl().s[14]++;
  var handleKeyDown = function handleKeyDown(e) {
    cov_1rawmllrvl().f[4]++;
    cov_1rawmllrvl().s[15]++;
    if (e.code === 'Enter') {
      cov_1rawmllrvl().b[11][0]++;
      cov_1rawmllrvl().s[16]++;
      setMenuIsOpen(function (isOpen) {
        cov_1rawmllrvl().f[5]++;
        cov_1rawmllrvl().s[17]++;
        return !isOpen;
      });
    } else {
      cov_1rawmllrvl().b[11][1]++;
    }
  };

  /**
   * We have to memoize `components` so the focus state doesn't get reset when we update `menuIsOpen`.
   */
  var components = (cov_1rawmllrvl().s[18]++, _react["default"].useMemo(function () {
    cov_1rawmllrvl().f[6]++;
    cov_1rawmllrvl().s[19]++;
    return (0, _shared.getComponents)(ariaLabelledby, customDropdownIndicator);
  }, [ariaLabelledby, customDropdownIndicator]));
  cov_1rawmllrvl().s[20]++;
  return /*#__PURE__*/_react["default"].createElement(_shared.SelectWrapper, {
    flexDirection: flexDirection,
    title: title,
    subtitle: subtitle,
    "aria-labelledby": ariaLabelledby,
    isRequired: isRequired,
    isDisabled: isDisabled,
    errorMsg: isInvalid ? (cov_1rawmllrvl().b[12][0]++, getErrorMessage()) : (cov_1rawmllrvl().b[12][1]++, null),
    helperText: helperText
  }, /*#__PURE__*/_react["default"].createElement(_async["default"], _extends({
    "aria-labelledby": ariaLabelledby,
    "aria-live": "assertive",
    components: components,
    filterOption: (_ref4 = (cov_1rawmllrvl().b[13][0]++, filterOption)) !== null && _ref4 !== void 0 ? _ref4 : (cov_1rawmllrvl().b[13][1]++, _shared.createSelectFilter),
    name: name,
    options: allowOther ? (cov_1rawmllrvl().b[14][0]++, _toConsumableArray(options)) : (cov_1rawmllrvl().b[14][1]++, options),
    placeholder: placeholder,
    onChange: onChange,
    value: selectedValue,
    theme: function theme(_theme) {
      cov_1rawmllrvl().f[7]++;
      cov_1rawmllrvl().s[21]++;
      return (0, _useSelectStyles.getSelectTheme)(_theme);
    },
    styles: getSelectStyles(isInvalid, 'large', paddingLevel, styles),
    maxMenuHeight: 170,
    isDisabled: isDisabled,
    menuIsOpen: menuIsOpen,
    onMenuOpen: handleMenuOpen,
    onMenuClose: handleMenuClose,
    onKeyDown: handleKeyDown
  }, rest)));
};